<template>
  <div>
    <div>
      <b-button class="backButton" type="is-primary" @click="$router.push('/').catch(()=>{})" outlined>
        Retour
      </b-button>
      <div style="text-align: center;">
        <img src="@/assets/logo.svg" class="logo align-top" alt="Dimsi">
      </div>
      <br>
    </div>
    <div class="commitments-content">
      <b-row fluid="lg">
        <b-col lg="2">
          <div class="commitments-menu d-none d-lg-block d-xl-block">
            <p class="summary-title">
              <b-img class="feat-img bg-rounded bg-icon p-2" src="../assets/Commitments/three-dots.svg" alt="cloud-img" />
              Sommaire
            </p>
            <p class="summary-item">
              <a class="summary-link" href="#introduction"> 
                <span class="summary-item-text">
                  Architecture
                </span>
              </a>
            </p>
            <p class="summary-item">
              <a class="summary-link" href="#assetmanagement">
                <span class="summary-item-text">
                  Gestion des actifs
                </span>
                </a>
            </p>
            <p class="summary-item">
              <a class="summary-link" href="#access">
                <span class="summary-item-text">
                  Contrôle d’accès et gestion<br>des identités
                </span>
              </a>
            </p>
            <p class="summary-item">
              <a class="summary-link" href="#security">
                <span class="summary-item-text">
                  Sécurité physique et environnementale
                </span>
              </a>
            </p>
            <p class="summary-item">
              <a class="summary-link" href="#safety">
                <span class="summary-item-text">
                  Sécurité liée à l’exploitation
                </span>
              </a>
            </p>
            <p class="summary-item">
              <a class="summary-link" href="#incident">
                <span class="summary-item-text">
                  Gestion des incidents<br>techniques et de sécurité
                </span>
              </a>
            </p>
            <p class="summary-item">
              <a class="summary-link" href="#activity">
                <span class="summary-item-text">
                  Continuité d’activité
                </span>
              </a>
            </p>
            <p class="summary-item">
              <a class="summary-link" href="#demands">
                <span class="summary-item-text">
                  Exigences supplémentaires
                </span>
              </a>
            </p>
          </div>

          <b-collapse id="collapse-1" class="mt-2 d-block d-md-block d-lg-none">
            <b-button style="background-color: #F4F7FF; color: #537DFB; font-weight: bold; border: none;" v-b-toggle.collapse-1-inner size="sm" block>
              Sommaire
              <b-icon icon="chevron-down" aria-hidden="true" />
            </b-button>
            <b-collapse id="collapse-1-inner" class="mt-2">
              <b-card style="background-color: #F4F7FF; border: none;">
                <p class="summary-item">
                  <a class="summary-link" href="#introduction"> 
                    <span class="summary-item-text">
                      Architecture
                    </span>
                  </a>
                </p>
                <p class="summary-item">
                  <a class="summary-link" href="#assetmanagement">
                    <span class="summary-item-text">
                      Gestion des actifs
                    </span>
                    </a>
                </p>
                <p class="summary-item">
                  <a class="summary-link" href="#access">
                    <span class="summary-item-text">
                      Contrôle d’accès et gestion des identités
                    </span>
                  </a>
                </p>
                <p class="summary-item">
                  <a class="summary-link" href="#security">
                    <span class="summary-item-text">
                      Sécurité physique et environnementale
                    </span>
                  </a>
                </p>
                <p class="summary-item">
                  <a class="summary-link" href="#safety">
                    <span class="summary-item-text">
                      Sécurité liée à l’exploitation
                    </span>
                  </a>
                </p>
                <p class="summary-item">
                  <a class="summary-link" href="#incident">
                    <span class="summary-item-text">
                      Gestion des incidents techniques et de sécurité
                    </span>
                  </a>
                </p>
                <p class="summary-item">
                  <a class="summary-link" href="#activity">
                    <span class="summary-item-text">
                      Continuité d’activité
                    </span>
                  </a>
                </p>
                <p class="summary-item">
                  <a class="summary-link" href="#demands">
                    <span class="summary-item-text">
                      Exigences supplémentaires
                    </span>
                  </a>
                </p>
              </b-card>
            </b-collapse>
          </b-collapse>

        </b-col>
        <b-col lg="10">
          <div class="d-md-block d-lg-none">
            <br>
          </div>
          <div class="commitments-subcontent">
            <Introduction id="introduction" />
            <AssetManagement id="assetmanagement" />
            <Access id="access" />
            <Security id="security" />
            <Safety id="safety" />
            <Incident id="incident" />
            <Activity id="activity" />
            <Demands id="demands" />
            <Table id="table" />
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script lang="ts">
import Introduction from '../components/Commitments/Introduction.vue'
import AssetManagement from '../components/Commitments/AssetManagement.vue'
import Access from '../components/Commitments/Access.vue'
import Security from '../components/Commitments/Security.vue'
import Safety from '../components/Commitments/Safety.vue'
import Incident from '../components/Commitments/Incident.vue'
import Demands from '../components/Commitments/Demands.vue'
import Activity from '../components/Commitments/Activity.vue'
import Table from '../components/Commitments/Table.vue'
export default {
  name: 'App',
  components: {
    Introduction,
    AssetManagement,
    Access,
    Security,
    Safety,
    Incident,
    Demands,
    Activity,
    Table
  }
}
</script>